import { AdapterFactory } from '../AdapterFactory';

export const reportsService = AdapterFactory.getReportsAdapter();
